import { PRODUCT_CATEGORY_TYPE, ProductInfoLabelType } from "@/types/productCard";

// 商品卡片的供给类型标签
export const ProductTagLabelMap = {
  [PRODUCT_CATEGORY_TYPE.WAIMAI]: "外卖",
  [PRODUCT_CATEGORY_TYPE.GROUP]: "团购",
  [PRODUCT_CATEGORY_TYPE.MEDICINE]: "快递",
};

// 商品卡片的供给类型标签的样式类
export const ProductTagStyleClassMap: Record<PRODUCT_CATEGORY_TYPE, string> = {
  [PRODUCT_CATEGORY_TYPE.WAIMAI]: "category-tag-waimai",
  [PRODUCT_CATEGORY_TYPE.GROUP]: "category-tag-group",
  [PRODUCT_CATEGORY_TYPE.MEDICINE]: "category-tag-medicine",
};

export const ProductInfoLabelClassMap: Record<ProductInfoLabelType, string> = {
  [ProductInfoLabelType.RANK]: "rank-tag",
  [ProductInfoLabelType.DIANPING_SCORE]: "high-score-tag",
  [ProductInfoLabelType.SALE_NUM]: "sale-num-tag",
};
